import { useContext, useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { printPDF } from 'Helpers'
import { interfaces } from 'service/interfaces'

import Comprobantes from './Comprobantes'
import { SALDOS } from './Saldos'

const CtaCteClient = (props) => {
  const { data, setData, dataBefore, setLoading, empresaId } = props
  const [edit] = useContext(EditContext)
  const [tab, setTab] = useState(0)
  const [isPrinting, setIsPrinting] = useState(false)

  const createDismissableSnackbar = useCustomSnackbar()

  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      ctaCliente: {
        ...prev.ctaCliente,
        saldos: {
          ...prev.ctaCliente.saldos,
          [name]: value,
        },
      },
    }))
  }

  const classes = useStyles()

  async function print() {
    const body = {
      empresa: empresaId,
      cliente_id: data.infoClient.id,
    }
    setIsPrinting(true)
    setLoading(true)
    await interfaces.salesClients
      .printCtaCte(body)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar('Cuenta corriente del cliente impreso con éxito!', {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal', {
          variant: 'error',
        })
      })
    setIsPrinting(false)
    setLoading(false)
  }

  function renderTabs(index) {
    switch (index) {
      case 0:
        return (
          <>
            <Comprobantes data={data.ctaCliente} dataBefore={dataBefore} />

            <div className={classes.buttons} style={{ marginTop: '10px' }}>
              <CustomButton
                buttonEnd
                style={{
                  marginLeft: '1.5rem',
                }}
                text="Imprimir"
                onClick={print}
                disabled={
                  !dataBefore.data.permissions.allowEdit &&
                  !dataBefore.data.permissions.allowEditParcial
                    ? true
                    : data.ctaCliente.comprobantes.length > 0
                      ? isPrinting
                      : true
                }
                isLoading={isPrinting}
              />

              {/* <CustomButton
                buttonEnd
                style={{
                  marginLeft: '1.5rem',
                }}
                text="Imprimir c/d"
                //   onClick={(e) => toggleStatus(e, data.info.id)}
              />

              <CustomButton
                buttonEnd
                color="primary"
                style={{
                  marginLeft: '1.5rem',
                }}
                text="+ Recibo"
                //   onClick={(e) => toggleStatus(e, data.info.id)}
              />

              <CustomButton
                buttonEnd
                color="primary"
                style={{
                  marginLeft: '1.5rem',
                }}
                text="+ Orden P"
                //   onClick={(e) => toggleStatus(e, data.info.id)}
              /> */}
            </div>
          </>
        )
      case 1:
        return (
          <InputsWithoutValidate
            fields={SALDOS(data.ctaCliente.saldos, handleChange, edit, dataBefore, data.infoClient)}
            spacing={2}
          />
        )
      default:
        break
    }
  }

  const verticalTabs = [
    {
      id: 0,
      title: 'Comprobantes',
    },
    {
      id: 1,
      title: 'Saldos',
    },
  ]

  return (
    <div>
      <ContentWithSubTabs
        listVerticalTabs={verticalTabs}
        value={tab}
        setValue={setTab}
        children={<div style={{ margin: '20px' }}>{renderTabs(tab)}</div>}
      />
    </div>
  )
}

export default CtaCteClient
